import styled from 'styled-components'

export const ChartContainerWrapper = styled.div`
	width: 100%;
	height: 100%;
`

export const TradeTextInnerTitle = styled.div<{
	$titleColor?: string;
	$titleBold?: boolean;
}>`
	margin-left: 1rem;
	padding-right: 2rem;
	color: ${(props) => props.theme.COLORS.textw};
	font-weight: 500;
	font-size: 15px;
	${({ $titleBold }) => $titleBold && ` font-weight: bold;`}
	${({ $titleColor }) => $titleColor && ` color:${$titleColor}`}
`
